import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMicrophone,
  faMicrophoneSlash,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";

const VoiceRecognitionBar = ({
  listening,
  transcript,
  toggleListening,
  onSubmitTranscript,
}: {
  listening: boolean;
  transcript: string;
  toggleListening: any;
  onSubmitTranscript: any;
}) => {
  return (
    <div className="flex flex-col bg-white dark:bg-gray-800 ">
      <div className="mt-3">
        <div>
          <div className="flex items-center justify-end mb-2">
            <button
              onClick={toggleListening}
              className={`bg-green-500 dark:bg-green-600 hover:bg-green-600 dark:hover:bg-green-700font-medium py-2 px-4 mr-2 rounded-full shadow-md focus:outline-none focus:ring-2 ${
                listening
                  ? "border-4 border-red-500 animate-pulse text-red-500"
                  : "focus:ring-green-300 dark:focus:ring-green-400 text-white "
              } flex items-center justify-center h-10 w-10`}
            >
              <FontAwesomeIcon icon={faMicrophone} className="text-xl" />
            </button>
            <button
              onClick={onSubmitTranscript}
              className="bg-blue-500 dark:bg-blue-600 hover:bg-blue-600 dark:hover:bg-blue-700 text-white font-medium py-2 px-3 rounded-full shadow-md focus:outline-none focus:ring-2 focus:ring-blue-300 dark:focus:ring-blue-400 whitespace-nowrap"
            >
              <FontAwesomeIcon icon={faPaperPlane} className="" />
            </button>
          </div>
          <div className="w-full border text-left border-gray-300 text-xl dark:border-gray-600 rounded-xl py-2 px-4 mr-2 bg-gray-100 dark:bg-gray-700 text-black dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400">
            <span className="mr-3 text-slate-600 font-bold dark:text-slate-300">
              {listening ? "듣는중..." : "마이크를 누르고 말해보세요!"}
            </span>
            <span>{transcript}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoiceRecognitionBar;
